import { formatNumber } from "devextreme/localization";

type Props = {
  value: number;
};

export default function TotalBalance({ value }: Props) {
  return (
    <div className="flex items-center justify-end gap-1 font-medium text-neutral-100 sm:min-w-[15rem]">
      Total Balance:
      <span className="max-w-[9rem]">{formatNumber(value, "currency")}</span>
    </div>
  );
}
